import { Button, Form, Input, message, Modal, Switch, Select} from 'antd';
import {useFetch, useFormLayout} from '@utils'
import React, {useEffect, useState} from 'react';
const { Option } = Select;

export default function UpdateTodoModal({
    isModalVisible, 
    setIsModalVisible, 
    record, 
    refresh
}){
    const [form] = Form.useForm()
    const layout = useFormLayout();
    const [doFetch, FetchOptions] = useFetch();
    const [isDone, setIsDone] = useState(record?.isDone)
    const [sl, setSl] = useState([]);

    useEffect(() => {
        form.setFieldsValue({
            description:record?.description
        });
        form.setFieldsValue({slId: record.larper.id})
        setIsDone(record?.isDone);

        doFetch(`/api/v2/story/GetSL`)
            .then((response) => slLoaded(response.isSuccess, response.result))

        function slLoaded(isSuccess, result) {
            if(isSuccess) {
                setSl(result)
            }
        }

    }, // eslint-disable-next-line
    [record])

    const slOptions = sl?.map(_ => {
        return (<Option 
            value={_.id} 
            key={_.id}
        >
            {_.name}
        </Option>)
    })

    function handleOk() {
        setIsModalVisible(false);
    }

    function handleCancel() {
        setIsModalVisible(false);
    }

    function onFinish(values) {

        const url = `/api/characterTodo`;
        const body = {
            id: record.id,
            description: values.description,
            isDone: isDone,
            larper: { id: values.slId}
        }

        doFetch(url, FetchOptions.PUT, body)
            .then((response) => onLoaded(response.isSuccess, response.result))

        function onLoaded(isSuccess, result) {
            if(isSuccess) {
                refresh()
                setIsModalVisible(false);
                return;
            } 

            message.error('Could not update');
        }
    }

    return (
            <Modal 
                title={`Update todo`}  
                visible={isModalVisible} 
                onOk={handleOk} 
                onCancel={handleCancel}
                footer={null}
                width={"80%"}
            >
                <Form 
                        form={form}
                        {...layout}
                        name="basic"
                        layout="horizontal"
                        onFinish={onFinish}
                        >
                        <Form.Item
                            label="Description"
                            name="description"
                        >
                            <Input 
                                name="description" 
                                />
                        </Form.Item>

                        <Form.Item
                            label="Is done?"
                            name="isDone"
                        >
                            <Switch checked={isDone} onChange={(value) => setIsDone(value)} name="isDone" />
                        </Form.Item>

                        <Form.Item
                                    label="SL"
                                    name="slId"
                                >
                                    <Select 
                                        name="slId" 
                                    >
                                        {slOptions}
                                    </Select>
                                </Form.Item>

                        <Form.Item >
                            <Button type="primary" htmlType="submit">
                                Update
                            </Button>
                        </Form.Item>

                    </Form>
            </Modal>
    )
}